import { render, staticRenderFns } from "./restaurant-settlement.vue?vue&type=template&id=90c32c46&"
import script from "./restaurant-settlement.vue?vue&type=script&lang=js&"
export * from "./restaurant-settlement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports